module.exports = __webpack_public_path__ + "img/icon-hash.7801ed34.svg";